import React from 'react';
import {
  Container,
  TutorialContainer,
  IconUtp,
  TextUtp,
  HelloUtp,
  PortalUtp,
  ButtonStart,
  ButtonFinish,
  ButtonContainer
} from './styled';
import IconTutorial from '../../../assets/icons/Tutorial.svg';

interface TutorialViewProps {
  onSkip: () => void;
  onStart: () => void;
}

const TutorialView = (props: TutorialViewProps) => {
  const { onSkip, onStart } = props;

  return (
    <Container data-testid="cmp-tutorial-view">
      <TutorialContainer>
        <IconUtp>
          <img src={IconTutorial} alt="IconTutorial" />
        </IconUtp>
        <TextUtp>
          <HelloUtp>¡Hola, Bienvenido a UTP+ portal!</HelloUtp>
          <PortalUtp>
            Descubre nuestros servicios y accede a la información actualizada
            que necesitas para tu vida universitaria.
          </PortalUtp>
        </TextUtp>
        <ButtonContainer>
          <ButtonStart
            id="btnGo"
            onClick={() => onStart()}
            type="button"
            data-testid="cmp-button-start"
          >
            ¡Empecemos!
          </ButtonStart>
          <ButtonFinish
            onClick={onSkip}
            type="button"
            data-testid="cmp-button-skip"
          >
            No, gracias
          </ButtonFinish>
        </ButtonContainer>
      </TutorialContainer>
    </Container>
  );
};

export default TutorialView;
